import type * as React from 'react';

type RadioDetailsProps = {
    children: React.ReactNode;
};

export function RadioDetails({ children }: RadioDetailsProps): React.ReactElement {
    return (
        <div className="flex min-w-0 flex-1 flex-grow basis-1/2 flex-col gap-2 rounded-lg border border-base border-l bg-[var(--sp-color-bg-visibility-properties)] p-4">
            {children}
        </div>
    );
}
